import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
    selector: '[ShDragData]',
    standalone: true
})
export class ShDragDataDirective implements OnChanges {
    @Input() ShDragData: string;

    constructor(
        private readonly el: ElementRef,
        private readonly renderer: Renderer2
    ) {}

    @HostListener('dragstart', ['$event']) OnDragStart(event: DragEvent) {
        if (this.ShDragData) {
            event.dataTransfer?.setData('text/plain', this.ShDragData);
        } else {
            console.error('ShDragDataDirective: no string value found for setData call');
        }
    }

    ngOnChanges() {
        if (this.ShDragData) {
            this.setNativeElementDraggable();
        }
    }

    private setNativeElementDraggable(): void {
        this.renderer.setAttribute(this.el.nativeElement, 'draggable', 'true');
    }
}
